import React from "react";
import createCustomStyles from "./generators/customStyles";
import createPalette from "./generators/palette";
import createTypography from "./generators/typography";
import * as utils from "./themeUtils";
function themeStrategy(args) {
  const { buildCssVars } = utils;
  const { ricosTheme = {} } = args;
  const {
    parentClass = "",
    palette,
    paletteConfig,
    typography,
    customStyles,
    settingsStyles,
    nativeStyle
  } = ricosTheme;
  const { paletteVarsObject, colors } = createPalette(palette, paletteConfig);
  const typographyVarsObject = createTypography(typography);
  const customsVarsObject = createCustomStyles({
    customStyles,
    settingsStyles,
    nativeStyle
  });
  const themeData = {
    colors,
    utils,
    customStyles
  };
  const html = /* @__PURE__ */ React.createElement("style", { type: "text/css", key: "styleElement" }, buildCssVars(parentClass, paletteVarsObject, typographyVarsObject, customsVarsObject));
  return {
    html,
    themeData
  };
}
export {
  themeStrategy as default
};
//# sourceMappingURL=themeStrategy.js.map
